import 'url-search-params-polyfill';
import axios from 'axios';
import config from 'config';

const TokenService = {
    fetch() {
        const body = new URLSearchParams();
        body.append('grant_type', 'client_credentials');

        return axios({
            method: 'post',
            url: `${config.endpoint.authentication}/token`,
            auth: {
                username: 'widgets',
                password: config.secrets.authentication,
            },
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            data: body,
        })
            .then(({ data }) => data.access_token)
            .catch((e) => {
                console.error('Unable to fetch the token', e);
                return Promise.reject();
            });
    },
};

export default TokenService;
